import { cn } from '@/shadcn/lib/utils';

interface Props {
    className?: string | string[];
    // onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
    onClick?: React.MouseEventHandler<SVGSVGElement>;
}

export function PlusOutlinedIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            viewBox="0 0 512 512"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                <path d="M256,0C114.833,0,0,114.833,0,256s114.833,256,256,256s256-114.853,256-256S397.167,0,256,0z M256,472.341 c-119.275,0-216.341-97.046-216.341-216.341S136.725,39.659,256,39.659S472.341,136.705,472.341,256S375.295,472.341,256,472.341z" />
            </g>

            <g>
                <path d="M355.148,234.386H275.83v-79.318c0-10.946-8.864-19.83-19.83-19.83s-19.83,8.884-19.83,19.83v79.318h-79.318 c-10.966,0-19.83,8.884-19.83,19.83s8.864,19.83,19.83,19.83h79.318v79.318c0,10.946,8.864,19.83,19.83,19.83 s19.83-8.884,19.83-19.83v-79.318h79.318c10.966,0,19.83-8.884,19.83-19.83S366.114,234.386,355.148,234.386z" />
            </g>
        </svg>
    );
}

export function UserOutlinedIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            id="Layer_1"
            enableBackground="new 0 0 100 100"
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="m50 2.5c-26.1917572 0-47.5 21.3082409-47.5 47.5s21.3082428 47.5 47.5 47.5 47.5-21.3082428 47.5-47.5-21.3082428-47.5-47.5-47.5zm28.8339462 76.1135483c-3.6421967-7.4900131-11.3205719-12.6594467-20.2055969-12.6594467h-17.2566986c-8.8850288 0-16.5634041 5.1694336-20.2055988 12.6594467-7.2950278-7.3506775-11.81038-17.4638176-11.81038-28.6135483 0-22.4114799 18.2333269-40.64433 40.6443281-40.64433s40.6443253 18.2328501 40.6443253 40.64433c0 11.1497307-4.5153504 21.2628708-11.8103791 28.6135483z" />
            <circle cx="50" cy="40.869" r="18.263" />
        </svg>
    );
}

export function StarIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="0 0 388.5 373.43"
        >
            <path d="M352.29,113.07l-84.53-12.28-37.8-76.6c-14.6-29.59-56.82-29.58-71.42,0l-37.8,76.6-84.53,12.28c-32.65,4.74-45.69,44.9-22.07,67.92l61.17,59.62-14.44,84.18c-5.58,32.52,28.58,57.33,57.78,41.98l75.61-39.75,75.61,39.75c29.16,15.33,63.36-9.46,57.78-41.98l-14.44-84.19,61.17-59.62c23.62-23.03,10.57-63.18-22.07-67.92ZM350.54,156.55l-67.59,65.88c-4.02,3.92-5.86,9.57-4.91,15.11l15.96,93.03c.8,4.67-4.06,8.2-8.25,6l-83.55-43.92c-4.97-2.61-10.91-2.61-15.88,0l-83.55,43.92c-4.2,2.2-9.05-1.33-8.25-6l15.96-93.03c.95-5.54-.89-11.18-4.91-15.11l-67.59-65.88c-3.39-3.31-1.54-9.02,3.15-9.7l93.41-13.57c5.56-.81,10.36-4.3,12.85-9.34l41.77-84.64c2.1-4.25,8.1-4.25,10.2,0l41.77,84.64c2.49,5.04,7.29,8.53,12.85,9.34l93.41,13.57c4.69.68,6.55,6.4,3.15,9.7Z" />
        </svg>
    );
}

export function SortIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="0 0 408.91 301.31"
        >
            <path d="M300.46,22.65c0,12.8-8.53,21.33-21.33,21.33H23.12c-12.8,0-21.33-8.53-21.33-21.33S10.32,1.32,23.12,1.32h256c12.8,0,21.33,8.53,21.33,21.33Z" />
            <path d="M236.46,129.32c0,12.8-8.53,21.33-21.33,21.33H23.12c-12.8,0-21.33-8.53-21.33-21.33s8.53-21.33,21.33-21.33h192c12.8,0,21.33,8.53,21.33,21.33Z" />
            <path d="M172.46,235.99c0,12.8-8.53,21.33-21.33,21.33H23.12c-12.8,0-21.33-8.53-21.33-21.33s8.53-21.33,21.33-21.33h128c12.8,0,21.33,8.53,21.33,21.33Z" />
            <path d="M343.12,107.99v170.67c0,12.8-8.53,21.33-21.33,21.33s-21.33-8.53-21.33-21.33V107.99c0-12.8,8.53-21.33,21.33-21.33s21.33,8.53,21.33,21.33Z" />
            <path d="M385.79,193.32c6.4,0,10.67,2.13,14.93,6.4,8.53,8.53,8.53,21.33,0,29.87l-64,64c-8.53,8.53-21.33,8.53-29.87,0l-64-64c-8.53-8.53-8.53-21.33,0-29.87,8.53-8.53,21.33-8.53,29.87,0l49.07,49.07,49.07-49.07c4.27-4.27,8.53-6.4,14.93-6.4h0Z" />
        </svg>
    );
}

export function LocationIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            width="512"
            height="512"
            x="0"
            y="0"
            viewBox="0 0 512 512"
        >
            <g>
                <path
                    d="M256 0C153.755 0 70.573 83.182 70.573 185.426c0 126.888 165.939 313.167 173.004 321.035 6.636 7.391 18.222 7.378 24.846 0 7.065-7.868 173.004-194.147 173.004-321.035C441.425 83.182 358.244 0 256 0zm0 278.719c-51.442 0-93.292-41.851-93.292-93.293S204.559 92.134 256 92.134s93.291 41.851 93.291 93.293-41.85 93.292-93.291 93.292z"
                    fill="currentColor"
                    opacity="1"
                    data-original="#000000"
                />
            </g>
        </svg>
    );
}

export function LocationOutlinedIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            id="Layer_1"
            height="512"
            viewBox="0 0 512.035 512.035"
            width="512"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill="currentColor"
                d="m407.554 62.854c-40.333-40.506-94.066-62.814-151.302-62.814h-.247c-115.256-2.359-216.371 99.143-213.998 214.357 3.017 81.355 81.282 184.674 142.23 264.051 17.899 21.382 43.979 33.587 71.997 33.587 29-.001 55.926-13.068 73.872-35.852 45.214-56.186 142.845-191.325 139.898-261.788.001-57.277-22.178-111.095-62.45-151.541zm-108.87 388.578c-20.669 27.264-64.148 27.313-84.825.047-82.643-105.233-131.854-192.87-131.854-237.083 0-96.14 78.056-174.355 174-174.355h.247c95.808 0 173.753 78.216 173.753 174.355 0 44.694-47.865 131.09-131.321 237.036zm-41.555-152.395c-46.869 0-85-38.131-85-85 4.669-112.764 165.348-112.731 170 .001 0 46.869-38.131 84.999-85 84.999zm0-130c-24.813 0-45 20.187-45 45 2.472 59.699 87.537 59.681 90 0 0-24.813-20.186-45-45-45z"
            />
        </svg>
    );
}

export function DoorIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            width="512"
            height="512"
            x="0"
            y="0"
            viewBox="0 0 492.5 492.5"
        >
            <g>
                <path
                    d="M184.646 0v21.72H99.704v433.358h31.403V53.123h53.539V492.5l208.15-37.422V37.5L184.646 0zm38.292 263.129c-6.997 0-12.67-7.381-12.67-16.486 0-9.104 5.673-16.485 12.67-16.485s12.67 7.381 12.67 16.485c0 9.105-5.673 16.486-12.67 16.486z"
                    fill="currentColor"
                    opacity="1"
                    data-original="#000000"
                />
            </g>
        </svg>
    );
}

export function ArrowLeftLongIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            id="svg10654"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 469.42 256.8"
        >
            <g id="layer1">
                <path
                    id="path9425"
                    d="M447.68,106.75l-374.54-.17,69.96-70.08c4.13-4.02,6.46-9.53,6.46-15.29-.16-19.01-23.21-28.34-36.54-14.79L6.27,113.04c-8.36,8.34-8.36,21.87,0,30.21l106.75,106.62c20.16,20.88,51.08-10.2,30.08-30.25l-70.37-70.38,374.96.17c12.03.21,21.85-9.56,21.73-21.58-.08-11.85-9.88-21.31-21.73-21.08h0Z"
                    vectorEffect="none"
                />
            </g>
        </svg>
    );
}

export function ArrowRightLongIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            id="svg10654"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 469.42 256.8"
        >
            <g id="layer1">
                <path
                    id="path9425"
                    d="M21.73,150.05l374.54.17-69.96,70.08c-4.13,4.02-6.46,9.53-6.46,15.29.16,19.01,23.21,28.34,36.54,14.79l106.75-106.63c8.36-8.34,8.36-21.87,0-30.21L356.4,6.93c-20.16-20.88-51.08,10.2-30.08,30.25l70.37,70.38-374.96-.17C9.71,107.17-.12,116.94,0,128.97c.08,11.85,9.88,21.31,21.73,21.08h0Z"
                    vectorEffect="none"
                />
            </g>
        </svg>
    );
}

export function ArrowRightIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            width="512"
            height="512"
            x="0"
            y="0"
            viewBox="0 0 466.205 466.205"
        >
            <g transform="matrix(6.062001655779402e-17,0.9900000000000007,-0.9900000000000007,6.062001655779402e-17,463.87407008696357,2.3312184034286076)">
                <path
                    d="m416.193 170.894-.158-.158-162.986-163.2a25.37 25.37 0 0 0-4.267-3.413l-4.693-2.56-3.2-1.067h-2.347a30.095 30.095 0 0 0-10.88 0h-4.693l-3.627 1.92a25.827 25.827 0 0 0-5.547 4.053L50.169 170.736c-10.957 10.87-11.028 28.565-.158 39.522l.158.158c11.045 10.538 28.421 10.538 39.467 0l97.493-97.28c4.206-4.124 10.96-4.058 15.084.149a10.662 10.662 0 0 1 3.049 7.318v317.653c-.001 15.435 12.51 27.948 27.945 27.949 15.435.001 27.947-12.51 27.949-27.945V120.603c.083-5.89 4.925-10.599 10.815-10.516 2.74.039 5.361 1.13 7.318 3.049l97.067 97.28c11.073 10.674 28.607 10.674 39.68 0 10.957-10.87 11.028-28.565.157-39.522z"
                    fill="currentColor"
                    opacity="1"
                    data-original="#000000"
                />
            </g>
        </svg>
    );
}

export function HouseIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            fill="none"
            height="512"
            viewBox="0 0 24 24"
            width="512"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                clipRule="evenodd"
                d="m13.8186 4.6664c-1.0747-.88853-2.5625-.88853-3.6371 0l-5.38611 4.45324c-.49114.40608-.79539 1.04766-.79539 1.74666v6.9446c0 1.2675.95214 2.1891 2 2.1891h2v-3.2522c0-2.2551 1.73415-4.1891 4-4.1891 2.2659 0 4 1.934 4 4.1891v3.2522h2c1.0479 0 2-.9216 2-2.1891v-6.9446c0-.699-.3042-1.34058-.7954-1.74665zm1.2744-1.54138 5.386 4.45325c.9704.80232 1.521 2.01878 1.521 3.28803v6.9446c0 2.2551-1.7341 4.1891-4 4.1891h-2c-1.1046 0-2-.8954-2-2v-3.2522c0-1.2675-.9521-2.1891-2-2.1891s-2 .9216-2 2.1891v3.2522c0 1.1046-.89543 2-2 2h-2c-2.26585 0-4-1.934-4-4.1891v-6.9446c0-1.26925.55059-2.48571 1.52097-3.28803l5.38606-4.45325c1.81427-1.50003 4.37167-1.50003 6.18597 0z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
}

export function PictureIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            clipRule="evenodd"
            fillRule="evenodd"
            height="512"
            strokeLinejoin="round"
            strokeMiterlimit="2"
            viewBox="0 0 24 24"
            width="512"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="Icon">
                <g>
                    <path d="m22.75 6c0-.729-.29-1.429-.805-1.945-.516-.515-1.216-.805-1.945-.805-3.832 0-12.168 0-16 0-.729 0-1.429.29-1.945.805-.515.516-.805 1.216-.805 1.945v12c0 .729.29 1.429.805 1.945.516.515 1.216.805 1.945.805h16c.729 0 1.429-.29 1.945-.805.515-.516.805-1.216.805-1.945zm-1.5 0v12c0 .332-.132.649-.366.884-.235.234-.552.366-.884.366h-16c-.332 0-.649-.132-.884-.366-.234-.235-.366-.552-.366-.884v-12c0-.332.132-.649.366-.884.235-.234.552-.366.884-.366h16c.332 0 .649.132.884.366.234.235.366.552.366.884z" />
                    <path d="m2.427 18.681c-.136.03-.266.097-.372.203-.292.293-.292.768 0 1.061l.134.124c.499.438 1.143.681 1.811.681h16c.729 0 1.429-.29 1.945-.805.515-.516.805-1.216.805-1.945v-2.181l-.001-.004c-.008-.376-.167-.522-.379-.542l-4.026-4.831c-.332-.399-.825-.63-1.344-.63s-1.012.231-1.344.63c0 0-3.531 4.237-3.531 4.237-.045.054-.111.086-.181.089-.07.004-.138-.023-.188-.073l-1.509-1.508c-.331-.332-.781-.516-1.249-.513-.469.003-.916.194-1.243.53l-5.328 5.477z" />
                    <circle cx="8" cy="8" r="1.75" />
                </g>
            </g>
        </svg>
    );
}

export function VideoIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 310 310"
        >
            <g id="XMLID_822_">
                <path
                    id="XMLID_823_"
                    d="M297.917,64.645c-11.19-13.302-31.85-18.728-71.306-18.728H83.386c-40.359,0-61.369,5.776-72.517,19.938   C0,79.663,0,100.008,0,128.166v53.669c0,54.551,12.896,82.248,83.386,82.248h143.226c34.216,0,53.176-4.788,65.442-16.527   C304.633,235.518,310,215.863,310,181.835v-53.669C310,98.471,309.159,78.006,297.917,64.645z M199.021,162.41l-65.038,33.991   c-1.454,0.76-3.044,1.137-4.632,1.137c-1.798,0-3.592-0.484-5.181-1.446c-2.992-1.813-4.819-5.056-4.819-8.554v-67.764   c0-3.492,1.822-6.732,4.808-8.546c2.987-1.814,6.702-1.938,9.801-0.328l65.038,33.772c3.309,1.718,5.387,5.134,5.392,8.861   C204.394,157.263,202.325,160.684,199.021,162.41z"
                />
            </g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
        </svg>
    );
}

export function AreaIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            version="1.1"
            id="svg795"
            xmlSpace="preserve"
            width="682.66669"
            height="682.66669"
            viewBox="0 0 682.66669 682.66669"
            xmlns="http://www.w3.org/2000/svg"
        >
            <defs id="defs799">
                <clipPath clipPathUnits="userSpaceOnUse" id="clipPath809">
                    <path d="M 0,512 H 512 V 0 H 0 Z" id="path807" />
                </clipPath>
            </defs>
            <g transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)">
                <g>
                    <g clipPath="url(#clipPath809)">
                        <g transform="translate(334.6665,20)">
                            <path
                                d="m 0,0 h -284.667 c -16.568,0 -30,13.432 -30,30 v 412 c 0,16.568 13.432,30 30,30 h 412 c 16.569,0 30,-13.432 30,-30 V 30 c 0,-16.568 -13.431,-30 -30,-30 H 78.667"
                                style={{
                                    fill: 'none',
                                    stroke: '#000000',
                                    strokeWidth: 40,
                                    strokeLinecap: 'round',
                                    strokeLinejoin: 'round',
                                    strokeMiterlimit: 10,
                                    strokeDasharray: 'none',
                                    strokeOpacity: 1,
                                }}
                            />
                        </g>
                        <g transform="translate(491.2539,254.9888)">
                            <path
                                d="M 0,0 H -195.92"
                                style={{
                                    fill: 'none',
                                    stroke: '#000000',
                                    strokeWidth: 40,
                                    strokeLinecap: 'round',
                                    strokeLinejoin: 'round',
                                    strokeMiterlimit: 10,
                                }}
                            />
                        </g>
                        <g transform="translate(216.0732,256)">
                            <path
                                d="M 0,0 H -196.073"
                                style={{
                                    fill: 'none',
                                    stroke: '#000000',
                                    strokeWidth: 40,
                                    strokeLinecap: 'round',
                                    strokeLinejoin: 'round',
                                    strokeMiterlimit: 10,
                                }}
                            />
                        </g>
                        <g transform="translate(216.0732,334.6665)">
                            <path
                                d="M 0,0 V -157.333"
                                style={{
                                    fill: 'none',
                                    stroke: '#000000',
                                    strokeWidth: 40,
                                    strokeLinecap: 'round',
                                    strokeLinejoin: 'round',
                                    strokeMiterlimit: 10,
                                }}
                            />
                        </g>
                        <g transform="translate(216.0732,413.3335)">
                            <path
                                d="M 0,0 V 78.667"
                                style={{
                                    fill: 'none',
                                    stroke: '#000000',
                                    strokeWidth: 40,
                                    strokeLinecap: 'round',
                                    strokeLinejoin: 'round',
                                    strokeMiterlimit: 10,
                                }}
                            />
                        </g>
                        <g transform="translate(216.0732,98.6665)">
                            <path
                                d="M 0,0 V -78.667"
                                style={{
                                    fill: 'none',
                                    stroke: '#000000',
                                    strokeWidth: 40,
                                    strokeLinecap: 'round',
                                    strokeLinejoin: 'round',
                                    strokeMiterlimit: 10,
                                }}
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export function CalendarIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            id="layer_1"
            height="512"
            viewBox="0 0 32 32"
            width="512"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="m20.2929688 16.0913086-5.6665039 5.6665039-2.9194336-2.9194336c-.390625-.390625-1.0234375-.390625-1.4140625 0s-.390625 1.0234375 0 1.4140625l3.6264648 3.6264648c.1953125.1953125.4511719.2929688.7070312.2929688s.5117188-.0976562.7070312-.2929688l6.3735352-6.3735352c.390625-.390625.390625-1.0234375 0-1.4140625s-1.0234374-.3906249-1.4140624.0000001z" />
            <path d="m25 3.9599609h-1.5v-.9599609c0-.5522461-.4477539-1-1-1s-1 .4477539-1 1v.9599609h-11v-.9599609c0-.5522461-.4477539-1-1-1s-1 .4477539-1 1v.9599609h-1.5c-2.7568359 0-5 2.2431641-5 5v16.0400391c0 2.7568359 2.2431641 5 5 5h18c2.7568359 0 5-2.2431641 5-5v-16.0400391c0-2.7568359-2.2431641-5-5-5zm-21 5c0-1.6542969 1.3457031-3 3-3h1.5v.9594727c0 .5522461.4477539 1 1 1s1-.4477539 1-1v-.9594727h11v.9594727c0 .5522461.4477539 1 1 1s1-.4477539 1-1v-.9594727h1.5c1.6542969 0 3 1.3457031 3 3v1.0097656h-24zm21 19.0400391h-18c-1.6542969 0-3-1.3457031-3-3v-13.0302734h24v13.0302734c0 1.6542969-1.3457031 3-3 3z" />
        </svg>
    );
}

export function ShinesIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
        >
            <g>
                <g>
                    <path d="M298.138,136.665c-62.065-13.011-110.576-61.522-123.585-123.588C172.955,5.458,166.235,0,158.448,0    s-14.507,5.458-16.104,13.078c-13.01,62.065-61.521,110.575-123.586,123.584c-7.62,1.597-13.079,8.318-13.079,16.104    s5.458,14.507,13.079,16.104c62.064,13.011,110.573,61.521,123.583,123.587c1.597,7.62,8.317,13.079,16.104,13.079    c7.786,0,14.507-5.458,16.104-13.079c13.011-62.065,61.523-110.575,123.588-123.583c7.62-1.597,13.079-8.317,13.079-16.104    C311.215,144.983,305.757,138.262,298.138,136.665z M158.446,239.333c-18.664-37.464-49.101-67.902-86.564-86.566    c37.464-18.664,67.902-49.101,86.566-86.565c18.664,37.465,49.101,67.902,86.564,86.567    C207.548,171.433,177.11,201.869,158.446,239.333z" />
                </g>
            </g>
            <g>
                <g>
                    <path d="M270.938,408.484c-29.242-6.129-52.098-28.985-58.229-58.229c-1.597-7.62-8.317-13.079-16.104-13.079    c-7.786,0-14.507,5.457-16.104,13.078c-6.131,29.243-28.988,52.099-58.23,58.229c-7.62,1.597-13.079,8.318-13.079,16.104    c0,7.786,5.458,14.507,13.079,16.104c29.241,6.13,52.098,28.987,58.228,58.23c1.597,7.62,8.317,13.079,16.104,13.079    c7.786,0,14.507-5.457,16.104-13.079c6.131-29.243,28.988-52.099,58.231-58.229c7.62-1.597,13.079-8.318,13.079-16.104    C284.017,416.802,278.559,410.082,270.938,408.484z M196.604,454.003c-7.808-11.607-17.808-21.605-29.413-29.414    c11.607-7.809,21.605-17.808,29.413-29.413c7.809,11.607,17.808,21.606,29.413,29.414    C214.412,432.397,204.412,442.396,196.604,454.003z" />
                </g>
            </g>
            <g>
                <g>
                    <path d="M493.243,256.135c-39.526-8.286-70.419-39.18-78.704-78.705c-1.597-7.62-8.317-13.079-16.104-13.079    c-7.786,0-14.507,5.457-16.104,13.078c-8.286,39.526-39.179,70.419-78.705,78.704c-7.62,1.597-13.079,8.318-13.079,16.104    c0,7.786,5.458,14.506,13.079,16.104c39.525,8.286,70.418,39.179,78.703,78.705c1.597,7.62,8.317,13.079,16.104,13.079    c7.786,0,14.507-5.457,16.104-13.079c8.287-39.526,39.18-70.419,78.705-78.703c7.62-1.598,13.079-8.318,13.079-16.104    S500.863,257.732,493.243,256.135z M398.435,319.007c-11.456-19.22-27.549-35.314-46.768-46.769    c19.219-11.455,35.312-27.547,46.768-46.768c11.456,19.221,27.548,35.314,46.768,46.769    C425.984,283.694,409.89,299.788,398.435,319.007z" />
                </g>
            </g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
        </svg>
    );
}

export function EnergyCertIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            id="Capa_1"
            height="512"
            viewBox="0 0 512 512"
            width="512"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="m437.02 76.713c-48.353-48.351-112.64-74.98-181.02-74.98s-132.667 26.629-181.02 74.98c-48.26 48.261-74.879 113.784-74.98 182.02 0 59.207 20.665 116.558 58.228 162.196 37.048 45.013 88.717 76.29 145.489 88.071 4.097.85 8.218 1.268 12.31 1.268 13.673-.001 26.999-4.67 37.837-13.489 14.056-11.436 22.119-28.388 22.123-46.51l.013-86.496c44.45-9.058 78.002-48.454 78.002-95.54v-51.5c0-11.046-8.954-20-20-20h-17v-51c0-11.046-8.954-20-20-20s-20 8.954-20 20v51h-40v-51c0-11.046-8.954-20-20-20s-20 8.954-20 20v51h-18c-11.046 0-20 8.954-20 20v51.5c0 46.73 33.048 85.881 76.998 95.324l-.013 86.705c-.001 8.263-4.617 13.252-7.368 15.49-4.707 3.829-10.821 5.318-16.774 4.082-99.464-20.64-171.689-109.375-171.866-211.101 0 0 .022.251.022 0 0-119.103 96.897-217 216-217s216 96.897 216 216c0 87.317-51.736 165.659-131.803 199.585-10.17 4.309-14.922 16.047-10.612 26.218s16.049 14.923 26.218 10.612c45.699-19.363 84.611-51.544 112.53-93.064 28.566-42.484 43.666-92.054 43.666-143.351 0-68.38-26.628-132.668-74.98-181.02zm-238.02 191.52v-31.5h115v31.5c0 31.706-25.794 57.5-57.5 57.5s-57.5-25.795-57.5-57.5z" />
        </svg>
    );
}

export function ShopIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            viewBox="0 0 512 512"
            fill="none"
            stroke="currentColor"
            strokeWidth={40}
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M296,56l160,160l-34.429,206.576C418.356,441.863,401.668,456,382.115,456h-252.23c-19.554,0-36.241-14.137-39.456-33.424L56,216L216,56" />
            <line x1="20" y1="216" x2="492" y2="216" />
            <line x1="176" y1="296" x2="176" y2="376" />
            <line x1="256" y1="296" x2="256" y2="376" />
            <line x1="336" y1="296" x2="336" y2="376" />
        </svg>
    );
}

export function BusIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            fill="none"
            height="24"
            viewBox="0 0 24 24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipRule="evenodd" fill="rgb(0,0,0)" fillRule="evenodd">
                <path d="m4.00635 3.76807c-.13807 0-.25.11192-.25.25v12.98443c0 .4142.33578.75.75.75h.99942c.41422 0 .75.3358.75.75v.4983c0 .6899.55928 1.2492 1.24915 1.2492.6899 0 1.2492-.5593 1.2492-1.2492v-.4983c0-.4142.33579-.75.75-.75h4.99828c.4142 0 .75.3358.75.75v.4975c0 .6903.5596 1.25 1.25 1.25.6903 0 1.2502-.5597 1.2502-1.25v-.4975c0-.4142.3358-.75.75-.75h.9976c.4142 0 .75-.3358.75-.75v-12.98443c0-.13806-.112-.25-.25-.25zm-1.75.25c0-.9665.7835-1.75 1.75-1.75h15.99385c.9664 0 1.75.78348 1.75 1.75v12.98443c0 1.2427-1.0074 2.25-2.25 2.25h-.2591c-.1274 1.4004-1.3048 2.4975-2.7385 2.4975s-2.6113-1.0971-2.7388-2.4975h-3.521c-.1272 1.4004-1.30443 2.4975-2.73788 2.4975-1.43347 0-2.61068-1.0972-2.73778-2.4975h-.26079c-1.24263 0-2.25-1.0074-2.25-2.25z" />
                <path d="m2.25 11.5c0-.4142.33579-.75.75-.75h18c.4142 0 .75.3358.75.75s-.3358.75-.75.75h-18c-.41421 0-.75-.3358-.75-.75z" />
                <path d="m6.25 6.5c0-.41421.33579-.75.75-.75h10c.4142 0 .75.33579.75.75v5c0 .4142-.3358.75-.75.75h-10c-.41421 0-.75-.3358-.75-.75zm1.5.75v3.5h8.5v-3.5z" />
                <path d="m6.25 15c0-.4142.33579-.75.75-.75h1c.41421 0 .75.3358.75.75s-.33579.75-.75.75h-1c-.41421 0-.75-.3358-.75-.75z" />
                <path d="m15.25 15c0-.4142.3358-.75.75-.75h1c.4142 0 .75.3358.75.75s-.3358.75-.75.75h-1c-.4142 0-.75-.3358-.75-.75z" />
            </g>
        </svg>
    );
}

export function PharmacyIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            fill="none"
            height="512"
            viewBox="0 0 24 24"
            width="512"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                clipRule="evenodd"
                d="m10 3c-.55228 0-1 .44772-1 1v4c0 .55228-.44772 1-1 1h-4c-.55228 0-1 .44772-1 1v4c0 .5523.44772 1 1 1h4c.55228 0 1 .4477 1 1v4c0 .5523.44772 1 1 1h4c.5523 0 1-.4477 1-1v-4c0-.5523.4477-1 1-1h4c.5523 0 1-.4477 1-1v-4c0-.55228-.4477-1-1-1h-4c-.5523 0-1-.44772-1-1v-4c0-.55228-.4477-1-1-1zm-3 1c0-1.65685 1.34315-3 3-3h4c1.6569 0 3 1.34315 3 3v3h3c1.6569 0 3 1.34315 3 3v4c0 1.6569-1.3431 3-3 3h-3v3c0 1.6569-1.3431 3-3 3h-4c-1.65685 0-3-1.3431-3-3v-3h-3c-1.65685 0-3-1.3431-3-3v-4c0-1.65685 1.34315-3 3-3h3z"
                fill="rgb(0,0,0)"
                fillRule="evenodd"
            />
        </svg>
    );
}

export function SchoolIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
        >
            <g>
                <g>
                    <path d="M256,193.944c-34.848,0-63.199,28.35-63.199,63.199c0,34.848,28.351,63.2,63.199,63.2c34.85,0,63.199-28.352,63.199-63.2    C319.199,222.294,290.849,193.944,256,193.944z M256,290.342c-18.305,0-33.199-14.894-33.199-33.2    c0-18.305,14.894-33.199,33.199-33.199c18.307,0,33.199,14.893,33.199,33.199C289.199,275.449,274.306,290.342,256,290.342z" />
                </g>
            </g>
            <g>
                <g>
                    <path d="M497,337.4h-81.4V200.422l10.926,4.967c2.014,0.915,4.123,1.349,6.199,1.349c5.701,0,11.15-3.269,13.664-8.797    c3.428-7.542,0.094-16.434-7.449-19.862L271,101.741V46.066h49.268c8.283,0,15-6.716,15-15V15c0-8.284-6.717-15-15-15H256    c-8.283,0-15,6.716-15,15v86.741L73.061,178.078c-7.541,3.428-10.877,12.32-7.447,19.862c3.426,7.542,12.32,10.875,19.861,7.448    l10.926-4.967V337.4H15c-8.283,0-15,6.716-15,15V497c0,8.284,6.717,15,15,15h96.4h96.4h96.398h96.4H497c8.285,0,15-6.716,15-15    V352.4C512,344.116,505.285,337.4,497,337.4z M96.4,482H30V367.4h66.4V482z M289.199,482h-66.398v-66.399h66.398V482z     M385.6,352.4V482h-66.4v-81.399c0-8.284-6.715-15-15-15h-96.398c-8.283,0-15,6.716-15,15V482h-66.4V352.4H126.4V186.785    L256,127.876l129.6,58.909V352.4z M482,482h-66.4V367.4H482V482z" />
                </g>
            </g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
        </svg>
    );
}

export function ArrowDownOutlined(props: Props) {
    return (
        <svg viewBox="0 0 19.8 19.8" className={cn(props.className)}>
            <path
                d="M1.8,9.9C1.8,5.43,5.43,1.8,9.9,1.8s8.1,3.63,8.1,8.1-3.63,8.1-8.1,8.1S1.8,14.37,1.8,9.9ZM9.9,0C4.43,0,0,4.43,0,9.9s4.43,9.9,9.9,9.9,9.9-4.43,9.9-9.9S15.37,0,9.9,0ZM7.24,8.26c-.35-.35-.92-.35-1.27,0s-.35.92,0,1.27l3.3,3.3c.35.35.92.35,1.27,0l3.3-3.3c.35-.35.35-.92,0-1.27s-.92-.35-1.27,0l-2.66,2.66-2.66-2.66Z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
}

export function PhoneOutlinedIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="0 0 513.64 513.64"
        >
            <path d="M13.98,446.08l48.64,48.64c51.2,51.2,186.88-5.12,307.2-125.44,120.32-120.32,174.08-256,125.44-307.2l-48.64-48.64c-17.92-17.92-48.64-17.92-69.12,0l-71.68,71.68c-25.6,25.6-15.36,69.12,17.92,79.36,23.04,7.68,38.4,33.28,30.72,56.32-12.8,53.76-81.92,120.32-133.12,133.12-23.04,5.12-48.64-7.68-56.32-30.72-10.24-33.28-53.76-43.52-79.36-17.92L13.98,376.96c-17.92,17.92-17.92,48.64,0,69.12Z" />
        </svg>
    );
}

export function MailIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            id="Layer_1"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="m12 16c-.6 0-1.1-.2-1.6-.4l-8.4-5.2v6.6c0 1.7 1.3 3 3 3h14c1.7 0 3-1.3 3-3v-6.6l-8.4 5.2c-.5.2-1 .4-1.6.4zm7-12h-14c-1.7 0-3 1.3-3 3v1.1l9.5 5.8c.3.2.7.2 1 0l9.5-5.8v-1.1c0-1.7-1.3-3-3-3z"
                fill="rgb(0,0,0)"
            />
        </svg>
    );
}

export function CloseIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="0 0 512.02 512.02"
            onClick={props.onClick}
        >
            <defs>
                <style>
                    {`
      .st0 {
        fill: #0d0d0d;
      }
          `}
                </style>
            </defs>
            <path
                className="st0"
                d="M317.94,256.01l181.24-181.24c17.1-17.11,17.1-44.84,0-61.93-17.11-17.1-44.82-17.1-61.93,0l-181.24,181.25L74.77,12.83C57.65-4.28,29.94-4.28,12.84,12.83c-17.1,17.09-17.1,44.82,0,61.93l181.25,181.25L12.84,437.26c-17.1,17.11-17.1,44.84,0,61.93,8.55,8.55,19.75,12.83,30.96,12.83s22.41-4.28,30.96-12.83l181.25-181.25,181.24,181.25c8.55,8.55,19.75,12.83,30.96,12.83s22.41-4.28,30.97-12.83c17.1-17.09,17.1-44.82,0-61.93l-181.24-181.25Z"
            />
        </svg>
    );
}

export function BadgeSuccessIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            width="512"
            height="512"
            x="0"
            y="0"
            viewBox="0 0 24 24"
        >
            <g>
                <path
                    d="M21.262 8.435a9.171 9.171 0 0 0-.176-.169c.002-.08.003-.161.003-.245 0-3.247-1.802-5.035-5.072-5.035-.087 0-.172.001-.257.004a7.512 7.512 0 0 0-.178-.182c-1.183-1.171-2.316-1.716-3.57-1.716s-2.427.561-3.598 1.72c-.06.059-.117.119-.173.177-.084-.002-.17-.003-.258-.003-3.271 0-5.072 1.788-5.072 5.035 0 .082 0 .163.004.243-.06.056-.118.113-.178.172C1.991 9.175 1 10.347 1 11.979c0 1.237.585 2.444 1.738 3.586.059.058.117.114.176.169-.002.08-.003.161-.003.245 0 3.247 1.802 5.035 5.072 5.035.086 0 .172-.001.256-.004.058.06.117.121.179.182 1.166 1.155 2.334 1.716 3.569 1.716 1.252 0 2.428-.561 3.599-1.72.06-.059.117-.119.174-.178.083.002.169.003.257.003 3.271 0 5.072-1.788 5.072-5.035 0-.082 0-.163-.004-.243l.178-.172C22.009 14.824 23 13.652 23 12.02c0-1.237-.585-2.444-1.738-3.586Zm-1.407 5.709a6.65 6.65 0 0 1-.435.397 1 1 0 0 0-.357.86c.018.185.026.378.026.578 0 2.127-.919 3.035-3.072 3.035-.212 0-.409-.008-.595-.024a1.017 1.017 0 0 0-.854.354 6.348 6.348 0 0 1-.393.426c-.773.766-1.489 1.138-2.188 1.138-.435 0-1.133-.118-2.161-1.137a6.76 6.76 0 0 1-.403-.433 1 1 0 0 0-.764-.354c-.03 0-.473.03-.676.03-2.153 0-3.072-.908-3.072-3.035 0-.21.008-.404.024-.585a.997.997 0 0 0-.363-.862 6.529 6.529 0 0 1-.428-.388c-.76-.752-1.145-1.479-1.145-2.164 0-.875.612-1.595 1.146-2.124.146-.145.292-.279.437-.399.252-.211.385-.532.355-.859a5.976 5.976 0 0 1-.026-.577c0-2.127.919-3.035 3.072-3.035.212 0 .408.007.592.024a.982.982 0 0 0 .856-.354c.118-.141.251-.285.393-.426.773-.766 1.489-1.138 2.188-1.138.436 0 1.134.118 2.161 1.136.149.149.283.292.402.433.211.25.522.38.857.351.186-.017.382-.026.584-.026 2.153 0 3.072.908 3.072 3.035 0 .21-.008.404-.024.585a.997.997 0 0 0 .363.862c.143.117.285.248.428.388.76.752 1.145 1.479 1.145 2.164 0 .875-.612 1.595-1.146 2.124Z"
                    fill="currentColor"
                    opacity="1"
                    data-original="#000000"
                />
                <path
                    d="M15.548 9.04a1 1 0 0 0-1.347.431c-.969 1.879-2.196 2.941-2.849 3.411-.475-.331-1.182-.882-1.635-1.502a1 1 0 0 0-1.615 1.179c.98 1.342 2.669 2.333 2.74 2.375a1.003 1.003 0 0 0 .954.029c.101-.051 2.485-1.284 4.182-4.576a1 1 0 0 0-.431-1.347Z"
                    fill="currentColor"
                    opacity="1"
                    data-original="#000000"
                />
            </g>
        </svg>
    );
}

export function ApartmentIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            width="512"
            height="512"
            x="0"
            y="0"
            viewBox="0 0 24 24"
        >
            <g>
                <path
                    d="M21.262 8.435a9.171 9.171 0 0 0-.176-.169c.002-.08.003-.161.003-.245 0-3.247-1.802-5.035-5.072-5.035-.087 0-.172.001-.257.004a7.512 7.512 0 0 0-.178-.182c-1.183-1.171-2.316-1.716-3.57-1.716s-2.427.561-3.598 1.72c-.06.059-.117.119-.173.177-.084-.002-.17-.003-.258-.003-3.271 0-5.072 1.788-5.072 5.035 0 .082 0 .163.004.243-.06.056-.118.113-.178.172C1.991 9.175 1 10.347 1 11.979c0 1.237.585 2.444 1.738 3.586.059.058.117.114.176.169-.002.08-.003.161-.003.245 0 3.247 1.802 5.035 5.072 5.035.086 0 .172-.001.256-.004.058.06.117.121.179.182 1.166 1.155 2.334 1.716 3.569 1.716 1.252 0 2.428-.561 3.599-1.72.06-.059.117-.119.174-.178.083.002.169.003.257.003 3.271 0 5.072-1.788 5.072-5.035 0-.082 0-.163-.004-.243l.178-.172C22.009 14.824 23 13.652 23 12.02c0-1.237-.585-2.444-1.738-3.586Zm-1.407 5.709a6.65 6.65 0 0 1-.435.397 1 1 0 0 0-.357.86c.018.185.026.378.026.578 0 2.127-.919 3.035-3.072 3.035-.212 0-.409-.008-.595-.024a1.017 1.017 0 0 0-.854.354 6.348 6.348 0 0 1-.393.426c-.773.766-1.489 1.138-2.188 1.138-.435 0-1.133-.118-2.161-1.137a6.76 6.76 0 0 1-.403-.433 1 1 0 0 0-.764-.354c-.03 0-.473.03-.676.03-2.153 0-3.072-.908-3.072-3.035 0-.21.008-.404.024-.585a.997.997 0 0 0-.363-.862 6.529 6.529 0 0 1-.428-.388c-.76-.752-1.145-1.479-1.145-2.164 0-.875.612-1.595 1.146-2.124.146-.145.292-.279.437-.399.252-.211.385-.532.355-.859a5.976 5.976 0 0 1-.026-.577c0-2.127.919-3.035 3.072-3.035.212 0 .408.007.592.024a.982.982 0 0 0 .856-.354c.118-.141.251-.285.393-.426.773-.766 1.489-1.138 2.188-1.138.436 0 1.134.118 2.161 1.136.149.149.283.292.402.433.211.25.522.38.857.351.186-.017.382-.026.584-.026 2.153 0 3.072.908 3.072 3.035 0 .21-.008.404-.024.585a.997.997 0 0 0 .363.862c.143.117.285.248.428.388.76.752 1.145 1.479 1.145 2.164 0 .875-.612 1.595-1.146 2.124Z"
                    fill="currentColor"
                    opacity="1"
                    data-original="#000000"
                />
                <path
                    d="M15.548 9.04a1 1 0 0 0-1.347.431c-.969 1.879-2.196 2.941-2.849 3.411-.475-.331-1.182-.882-1.635-1.502a1 1 0 0 0-1.615 1.179c.98 1.342 2.669 2.333 2.74 2.375a1.003 1.003 0 0 0 .954.029c.101-.051 2.485-1.284 4.182-4.576a1 1 0 0 0-.431-1.347Z"
                    fill="currentColor"
                    opacity="1"
                    data-original="#000000"
                />
            </g>
        </svg>
    );
}

export function HouseOutlinedIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            width="512"
            height="512"
            x="0"
            y="0"
            viewBox="0 0 24 24"
        >
            <g>
                <path
                    d="M14 10h-4c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2h4c1.103 0 2-.897 2-2v-4c0-1.103-.897-2-2-2Zm-4 6v-4h4v4h-4ZM22 5.724V2a1 1 0 1 0-2 0v2.367L14.797.855a4.98 4.98 0 0 0-5.594 0L2.204 5.579A4.992 4.992 0 0 0 0 9.724V19c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5V9.724a4.992 4.992 0 0 0-2-3.999ZM22 19c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3V9.724c0-.999.494-1.928 1.322-2.486l7-4.724c.51-.345 1.094-.517 1.678-.517s1.168.172 1.678.517l7 4.724A2.994 2.994 0 0 1 22 9.724V19Z"
                    fill="currentColor"
                    opacity="1"
                    data-original="#000000"
                />
            </g>
        </svg>
    );
}

export function LandIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            width="512"
            height="512"
            x="0"
            y="0"
            viewBox="0 0 512 512"
        >
            <g>
                <path
                    d="M477.331 205.581C356.3 243.254 315.493 330.962 301.729 386.37c-1.888-39.479-3.838-137.807 15.415-240.8a2.807 2.807 0 0 0-4.9-2.334C292.4 166.83 235.955 243.77 231.778 359.91c0 0-33.118-221.126-178.559-287.792a2.816 2.816 0 0 0-3.595 4c20.5 34.046 102.084 176.016 102.972 280.742 0 0-55.511-53.629-118.526-59.44a2.814 2.814 0 0 0-2.274 4.757c19.423 20.091 88.165 92.8 93.391 120.668l1.177 7.061h-41.2a5.27 5.27 0 0 0-5.317 4.617 5.123 5.123 0 0 0 5.1 5.625h340.385a5.271 5.271 0 0 0 5.317-4.618 5.122 5.122 0 0 0-5.1-5.624H366.44c14.569-106.032 89.8-194.005 113.792-219.728a2.814 2.814 0 0 0-2.901-4.597z"
                    fill="currentColor"
                    opacity="1"
                    data-original="#000000"
                />
            </g>
        </svg>
    );
}

export function PropertyOtherIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            width="512"
            height="512"
            x="0"
            y="0"
            viewBox="0 0 512 512"
        >
            <g>
                <circle
                    cx="66.2"
                    cy="256"
                    r="66.2"
                    fill="currentColor"
                    opacity="1"
                    data-original="#000000"
                />
                <circle
                    cx="256"
                    cy="256"
                    r="66.2"
                    fill="currentColor"
                    opacity="1"
                    data-original="#000000"
                />
                <circle
                    cx="445.8"
                    cy="256"
                    r="66.2"
                    fill="currentColor"
                    opacity="1"
                    data-original="#000000"
                />
            </g>
        </svg>
    );
}

export function PropertyRecreationalIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            width="512"
            height="512"
            x="0"
            y="0"
            viewBox="0 0 100 100"
        >
            <g>
                <path
                    d="M48.06 97.5C23.228 96.714 3.297 76.772 2.5 51.952 27.19 53.054 46.946 72.821 48.06 97.5z"
                    fill="currentColor"
                    opacity="1"
                    data-original="#000000"
                />
                <path
                    d="M97.113 55.985c-2.45 21.62-19.509 38.678-41.128 41.128-1.29-28.77-24.327-51.809-53.098-53.098 2.45-21.62 19.509-38.678 41.128-41.128 1.29 28.77 24.327 51.797 53.098 53.098z"
                    fill="currentColor"
                    opacity="1"
                    data-original="#000000"
                />
                <path
                    d="M97.5 48.048C72.797 46.958 53.03 27.19 51.94 2.5c24.832.786 44.775 20.728 45.56 45.548z"
                    fill="currentColor"
                    opacity="1"
                    data-original="#000000"
                />
            </g>
        </svg>
    );
}

export function FilterIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 30.12 23.9"
        >
            <defs>=</defs>
            <path
                className="cls-1"
                d="M29.07,17.12H11.36l-.09-.38c-.65-2.52-2.93-4.29-5.55-4.29-3.15,0-5.72,2.57-5.72,5.73s2.57,5.72,5.72,5.72c2.62,0,4.9-1.77,5.55-4.29l.09-.38h17.71c.58,0,1.05-.47,1.05-1.05s-.47-1.06-1.05-1.06ZM5.72,21.79c-1.99,0-3.61-1.62-3.61-3.61s1.62-3.62,3.61-3.62,3.62,1.62,3.62,3.62-1.63,3.61-3.62,3.61ZM24.4,0c-2.62,0-4.9,1.77-5.55,4.29l-.09.38H1.05c-.58,0-1.05.47-1.05,1.05s.47,1.06,1.05,1.06h17.71l.09.38c.65,2.52,2.93,4.29,5.55,4.29,3.15,0,5.72-2.57,5.72-5.73S27.55,0,24.4,0ZM24.4,9.34c-1.99,0-3.61-1.62-3.61-3.62s1.62-3.61,3.61-3.61,3.61,1.62,3.61,3.61-1.62,3.62-3.61,3.62Z"
            />
        </svg>
    );
}

export function StarFilledIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="0 0 512 491.54"
        >
            <defs></defs>
            <path
                className="st0"
                d="M497.7,232.7c12.98-12.64,17.55-31.19,11.95-48.41-5.59-17.22-20.2-29.54-38.13-32.15l-110.69-16.08c-5.62-.82-10.47-4.35-12.99-9.43l-49.5-100.31c-8.02-16.24-24.24-26.32-42.35-26.32s-34.34,10.08-42.35,26.32c0,0-49.5,100.31-49.5,100.31-2.51,5.09-7.37,8.62-12.98,9.43l-110.69,16.08c-17.93,2.61-32.54,14.92-38.12,32.14-5.6,17.23-1.02,35.78,11.95,48.42l80.1,78.08c4.06,3.96,5.92,9.66,4.96,15.25l-18.91,110.25c-3.06,17.85,4.14,35.55,18.79,46.19,14.65,10.64,33.71,12.02,49.74,3.6l99-52.05c5.02-2.64,11.02-2.64,16.04,0l99.01,52.05c16.04,8.42,35.1,7.04,49.74-3.6,14.64-10.64,21.84-28.34,18.79-46.19l-18.91-110.25c-.96-5.59.9-11.3,4.96-15.26l80.09-78.08Z"
            />
        </svg>
    );
}

export function YoutubeIcon(props: Props) {
    return (
        <svg
            fill="currentColor"
            className={cn(props.className)}
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 310 310"
        >
            <g id="XMLID_822_">
                <path
                    id="XMLID_823_"
                    d="M297.917,64.645c-11.19-13.302-31.85-18.728-71.306-18.728H83.386c-40.359,0-61.369,5.776-72.517,19.938   C0,79.663,0,100.008,0,128.166v53.669c0,54.551,12.896,82.248,83.386,82.248h143.226c34.216,0,53.176-4.788,65.442-16.527   C304.633,235.518,310,215.863,310,181.835v-53.669C310,98.471,309.159,78.006,297.917,64.645z M199.021,162.41l-65.038,33.991   c-1.454,0.76-3.044,1.137-4.632,1.137c-1.798,0-3.592-0.484-5.181-1.446c-2.992-1.813-4.819-5.056-4.819-8.554v-67.764   c0-3.492,1.822-6.732,4.808-8.546c2.987-1.814,6.702-1.938,9.801-0.328l65.038,33.772c3.309,1.718,5.387,5.134,5.392,8.861   C204.394,157.263,202.325,160.684,199.021,162.41z"
                />
            </g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
        </svg>
    );
}

export function Survey3DIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="0 0 512 512"
        >
            <defs></defs>
            <path
                fill="currentColor"
                d="M156.7,156.7c6.11-47.65,19.73-111.26,46.04-151.17C104.23,26.27,26.29,104.14,5.53,202.75c39.9-26.31,103.51-39.94,151.17-46.04Z"
            />
            <path
                fill="currentColor"
                d="M187.43,153.44c44.65-3.79,92.13-3.82,137.13,0C311.07,56.48,279.94,0,256,0s-55.07,56.48-68.57,153.44h0Z"
            />
            <path
                fill="currentColor"
                d="M358.56,187.43c3.8,44.8,3.81,92.31,0,137.13,96.96-13.49,153.44-44.63,153.44-68.57s-56.48-55.07-153.44-68.57h0Z"
            />
            <path
                fill="currentColor"
                d="M355.3,156.7c47.63,6.11,111.26,19.73,151.17,46.04C485.73,104.23,407.86,26.29,309.25,5.53c26.31,39.9,39.93,103.51,46.04,151.17Z"
            />
            <path
                fill="currentColor"
                d="M355.3,355.3c-6.11,47.63-19.73,111.26-46.04,151.17,98.52-20.74,176.46-98.61,197.21-197.21-39.91,26.31-103.53,39.94-151.17,46.04h0Z"
            />
            <path
                fill="currentColor"
                d="M183.92,183.92c-4.29,46.5-4.29,97.65,0,144.15,46.4,4.28,97.56,4.3,144.15,0,4.29-46.49,4.29-97.65,0-144.15-46.4-4.29-97.56-4.3-144.15,0h0Z"
            />
            <path
                fill="currentColor"
                d="M324.57,358.56c-44.65,3.79-92.13,3.82-137.13,0,13.49,96.96,44.63,153.44,68.57,153.44s55.07-56.48,68.57-153.44h0Z"
            />
            <path
                fill="currentColor"
                d="M153.44,324.57c-3.8-44.8-3.81-92.31,0-137.13C56.48,200.93,0,232.06,0,256s56.48,55.07,153.44,68.57Z"
            />
            <path
                fill="currentColor"
                d="M156.7,355.3c-47.63-6.1-111.26-19.73-151.17-46.04,20.74,98.52,98.61,176.46,197.21,197.21-26.31-39.91-39.94-103.53-46.04-151.17h0Z"
            />
        </svg>
    );
}

export function FloorPlan3DIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 310 310"
        >
            <g id="XMLID_822_">
                <path
                    id="XMLID_823_"
                    d="M297.917,64.645c-11.19-13.302-31.85-18.728-71.306-18.728H83.386c-40.359,0-61.369,5.776-72.517,19.938   C0,79.663,0,100.008,0,128.166v53.669c0,54.551,12.896,82.248,83.386,82.248h143.226c34.216,0,53.176-4.788,65.442-16.527   C304.633,235.518,310,215.863,310,181.835v-53.669C310,98.471,309.159,78.006,297.917,64.645z M199.021,162.41l-65.038,33.991   c-1.454,0.76-3.044,1.137-4.632,1.137c-1.798,0-3.592-0.484-5.181-1.446c-2.992-1.813-4.819-5.056-4.819-8.554v-67.764   c0-3.492,1.822-6.732,4.808-8.546c2.987-1.814,6.702-1.938,9.801-0.328l65.038,33.772c3.309,1.718,5.387,5.134,5.392,8.861   C204.394,157.263,202.325,160.684,199.021,162.41z"
                />
            </g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
        </svg>
    );
}

export function WorkIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            version="1.1"
            id="Capa_1"
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
        >
            <g>
                <g>
                    <g>
                        <path d="M469.333,106.667H362.667V85.333c0-23.531-19.135-42.667-42.667-42.667H192c-23.531,0-42.667,19.135-42.667,42.667     v21.333H42.667C19.135,106.667,0,125.802,0,149.333v64C0,236.865,19.135,256,42.667,256h170.667v-10.667     c0-5.896,4.771-10.667,10.667-10.667h64c5.896,0,10.667,4.771,10.667,10.667V256h170.667C492.865,256,512,236.865,512,213.333     v-64C512,125.802,492.865,106.667,469.333,106.667z M320,106.667H192V85.333h128V106.667z" />
                        <path d="M506.083,267.51c-3.635-1.802-7.979-1.385-11.188,1.052c-7.583,5.74-16.417,8.771-25.563,8.771H298.667v32     c0,5.896-4.771,10.667-10.667,10.667h-64c-5.896,0-10.667-4.771-10.667-10.667v-32H42.667c-9.146,0-17.979-3.031-25.563-8.771     c-3.219-2.458-7.552-2.875-11.188-1.052C2.292,269.313,0,273.01,0,277.063v149.604c0,23.531,19.135,42.667,42.667,42.667h426.667     c23.531,0,42.667-19.135,42.667-42.667V277.063C512,273.01,509.708,269.313,506.083,267.51z" />
                    </g>
                </g>
            </g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
        </svg>
    );
}

export function BuildingOfficeIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 601.1 591.04"
        >
            <g id="OWmaME">
                <g>
                    <path d="M0,41.54C3.02,19.18,27.23-.02,49.51.05l303.03-.05c25.35.53,46.96,18.26,50.44,43.56l.02,226.99c-.49,2.53-9.43,7.65-12.02,9.98-11.86,10.65-21.7,22.84-28.84,37.16l-7.14,18.36V49.54l-1.5-1.5H48v495h258v48H0" />
                    <path d="M471.79,313.33c58.01-5.3,94.74,60.82,60.62,107.62-26.75,36.69-82.98,36.48-109.23-.6-30.15-42.58-3.32-102.28,48.61-107.02Z" />
                    <path d="M177,421.04v54c-.73.27-1.2-1-1.5-1h-79c-.35,0-1.11,1.77-2.5-.5v-51l1.5-1.5h81.5Z" />
                    <rect x="94" y="217.04" width="83" height="53" />
                    <rect x="226" y="217.04" width="83" height="53" />
                    <rect x="94" y="114.54" width="83" height="53" />
                    <rect x="226" y="114.54" width="83" height="53" />
                    <rect x="94" y="319.04" width="83" height="53" />
                    <rect x="226" y="319.04" width="83" height="53" />
                    <rect x="226" y="421.04" width="83" height="53" />
                </g>
            </g>
            <path d="M601.1,591.04h-50v-42.49c0-14.38-11.7-26.09-26.09-26.09h-96.05c-14.38,0-26.09,11.7-26.09,26.09v42.49h-50v-42.49c0-41.95,34.13-76.09,76.09-76.09h96.05c41.95,0,76.09,34.13,76.09,76.09v42.49Z" />
        </svg>
    );
}

export function UserIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
        >
            <g>
                <g>
                    <path d="M437.02,330.98c-27.883-27.882-61.071-48.523-97.281-61.018C378.521,243.251,404,198.548,404,148    C404,66.393,337.607,0,256,0S108,66.393,108,148c0,50.548,25.479,95.251,64.262,121.962    c-36.21,12.495-69.398,33.136-97.281,61.018C26.629,379.333,0,443.62,0,512h40c0-119.103,96.897-216,216-216s216,96.897,216,216    h40C512,443.62,485.371,379.333,437.02,330.98z M256,256c-59.551,0-108-48.448-108-108S196.449,40,256,40    c59.551,0,108,48.448,108,108S315.551,256,256,256z" />
                </g>
            </g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
        </svg>
    );
}

export function FacebookIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 155.139 155.139"
        >
            <g>
                <path
                    id="f_1_"
                    style={{ fill: '#010002' }}
                    d="M89.584,155.139V84.378h23.742l3.562-27.585H89.584V39.184   c0-7.984,2.208-13.425,13.67-13.425l14.595-0.006V1.08C115.325,0.752,106.661,0,96.577,0C75.52,0,61.104,12.853,61.104,36.452   v20.341H37.29v27.585h23.814v70.761H89.584z"
                />
            </g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
        </svg>
    );
}

export function InstagramIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            height="511pt"
            viewBox="0 0 511 511.9"
            width="511pt"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="m510.949219 150.5c-1.199219-27.199219-5.597657-45.898438-11.898438-62.101562-6.5-17.199219-16.5-32.597657-29.601562-45.398438-12.800781-13-28.300781-23.101562-45.300781-29.5-16.296876-6.300781-34.898438-10.699219-62.097657-11.898438-27.402343-1.300781-36.101562-1.601562-105.601562-1.601562s-78.199219.300781-105.5 1.5c-27.199219 1.199219-45.898438 5.601562-62.097657 11.898438-17.203124 6.5-32.601562 16.5-45.402343 29.601562-13 12.800781-23.097657 28.300781-29.5 45.300781-6.300781 16.300781-10.699219 34.898438-11.898438 62.097657-1.300781 27.402343-1.601562 36.101562-1.601562 105.601562s.300781 78.199219 1.5 105.5c1.199219 27.199219 5.601562 45.898438 11.902343 62.101562 6.5 17.199219 16.597657 32.597657 29.597657 45.398438 12.800781 13 28.300781 23.101562 45.300781 29.5 16.300781 6.300781 34.898438 10.699219 62.101562 11.898438 27.296876 1.203124 36 1.5 105.5 1.5s78.199219-.296876 105.5-1.5c27.199219-1.199219 45.898438-5.597657 62.097657-11.898438 34.402343-13.300781 61.601562-40.5 74.902343-74.898438 6.296876-16.300781 10.699219-34.902343 11.898438-62.101562 1.199219-27.300781 1.5-36 1.5-105.5s-.101562-78.199219-1.300781-105.5zm-46.097657 209c-1.101562 25-5.300781 38.5-8.800781 47.5-8.601562 22.300781-26.300781 40-48.601562 48.601562-9 3.5-22.597657 7.699219-47.5 8.796876-27 1.203124-35.097657 1.5-103.398438 1.5s-76.5-.296876-103.402343-1.5c-25-1.097657-38.5-5.296876-47.5-8.796876-11.097657-4.101562-21.199219-10.601562-29.398438-19.101562-8.5-8.300781-15-18.300781-19.101562-29.398438-3.5-9-7.699219-22.601562-8.796876-47.5-1.203124-27-1.5-35.101562-1.5-103.402343s.296876-76.5 1.5-103.398438c1.097657-25 5.296876-38.5 8.796876-47.5 4.101562-11.101562 10.601562-21.199219 19.203124-29.402343 8.296876-8.5 18.296876-15 29.398438-19.097657 9-3.5 22.601562-7.699219 47.5-8.800781 27-1.199219 35.101562-1.5 103.398438-1.5 68.402343 0 76.5.300781 103.402343 1.5 25 1.101562 38.5 5.300781 47.5 8.800781 11.097657 4.097657 21.199219 10.597657 29.398438 19.097657 8.5 8.300781 15 18.300781 19.101562 29.402343 3.5 9 7.699219 22.597657 8.800781 47.5 1.199219 27 1.5 35.097657 1.5 103.398438s-.300781 76.300781-1.5 103.300781zm0 0" />
            <path d="m256.449219 124.5c-72.597657 0-131.5 58.898438-131.5 131.5s58.902343 131.5 131.5 131.5c72.601562 0 131.5-58.898438 131.5-131.5s-58.898438-131.5-131.5-131.5zm0 216.800781c-47.097657 0-85.300781-38.199219-85.300781-85.300781s38.203124-85.300781 85.300781-85.300781c47.101562 0 85.300781 38.199219 85.300781 85.300781s-38.199219 85.300781-85.300781 85.300781zm0 0" />
            <path d="m423.851562 119.300781c0 16.953125-13.746093 30.699219-30.703124 30.699219-16.953126 0-30.699219-13.746094-30.699219-30.699219 0-16.957031 13.746093-30.699219 30.699219-30.699219 16.957031 0 30.703124 13.742188 30.703124 30.699219zm0 0" />
        </svg>
    );
}

export function LinkedinIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            id="Layer_1"
            enable-background="new 0 0 100 100"
            height="512"
            viewBox="0 0 100 100"
            width="512"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="_x31_0.Linkedin">
                <path d="m90 90v-29.3c0-14.4-3.1-25.4-19.9-25.4-8.1 0-13.5 4.4-15.7 8.6h-.2v-7.3h-15.9v53.4h16.6v-26.5c0-7 1.3-13.7 9.9-13.7 8.5 0 8.6 7.9 8.6 14.1v26h16.6z" />
                <path d="m11.3 36.6h16.6v53.4h-16.6z" />
                <path d="m19.6 10c-5.3 0-9.6 4.3-9.6 9.6s4.3 9.7 9.6 9.7 9.6-4.4 9.6-9.7-4.3-9.6-9.6-9.6z" />
            </g>
        </svg>
    );
}

export function WhatsappIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
        >
            <g>
                <g>
                    <path d="M256.064,0h-0.128C114.784,0,0,114.816,0,256c0,56,18.048,107.904,48.736,150.048l-31.904,95.104l98.4-31.456    C155.712,496.512,204,512,256.064,512C397.216,512,512,397.152,512,256S397.216,0,256.064,0z M405.024,361.504    c-6.176,17.44-30.688,31.904-50.24,36.128c-13.376,2.848-30.848,5.12-89.664-19.264C189.888,347.2,141.44,270.752,137.664,265.792    c-3.616-4.96-30.4-40.48-30.4-77.216s18.656-54.624,26.176-62.304c6.176-6.304,16.384-9.184,26.176-9.184    c3.168,0,6.016,0.16,8.576,0.288c7.52,0.32,11.296,0.768,16.256,12.64c6.176,14.88,21.216,51.616,23.008,55.392    c1.824,3.776,3.648,8.896,1.088,13.856c-2.4,5.12-4.512,7.392-8.288,11.744c-3.776,4.352-7.36,7.68-11.136,12.352    c-3.456,4.064-7.36,8.416-3.008,15.936c4.352,7.36,19.392,31.904,41.536,51.616c28.576,25.44,51.744,33.568,60.032,37.024    c6.176,2.56,13.536,1.952,18.048-2.848c5.728-6.176,12.8-16.416,20-26.496c5.12-7.232,11.584-8.128,18.368-5.568    c6.912,2.4,43.488,20.48,51.008,24.224c7.52,3.776,12.48,5.568,14.304,8.736C411.2,329.152,411.2,344.032,405.024,361.504z" />
                </g>
            </g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
        </svg>
    );
}

export function MessageIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            height="512"
            viewBox="0 0 512 512"
            width="512"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="m408 48h-304a72.08 72.08 0 0 0 -72 72v192a72.08 72.08 0 0 0 72 72h24v64a16 16 0 0 0 26.25 12.29l91.49-76.29h162.26a72.08 72.08 0 0 0 72-72v-192a72.08 72.08 0 0 0 -72-72zm-248 200a32 32 0 1 1 32-32 32 32 0 0 1 -32 32zm96 0a32 32 0 1 1 32-32 32 32 0 0 1 -32 32zm96 0a32 32 0 1 1 32-32 32 32 0 0 1 -32 32z" />
        </svg>
    );
}

export function PhoneIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 513.64 513.64"
        >
            <g>
                <g>
                    <path d="M499.66,376.96l-71.68-71.68c-25.6-25.6-69.12-15.359-79.36,17.92c-7.68,23.041-33.28,35.841-56.32,30.72    c-51.2-12.8-120.32-79.36-133.12-133.12c-7.68-23.041,7.68-48.641,30.72-56.32c33.28-10.24,43.52-53.76,17.92-79.36l-71.68-71.68    c-20.48-17.92-51.2-17.92-69.12,0l-48.64,48.64c-48.64,51.2,5.12,186.88,125.44,307.2c120.32,120.32,256,176.641,307.2,125.44    l48.64-48.64C517.581,425.6,517.581,394.88,499.66,376.96z" />
                </g>
            </g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
        </svg>
    );
}

export function BalconyIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            viewBox="0 0 1024 1024"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
        >
            <path d="m858.08 575.49c-24.25 0-48.51 0-72.76 0-16.45 0-32.91 0-49.36 0-29.05 0-58.09 0-87.14 0-18.11 0-36.21 0-54.32 0-11.27 0-22.54 0-33.81 0-25.2 0-50.4 0-75.6 0-32.41 0-64.82 0-97.24 0-32.91 0-65.82 0-98.72 0-26.69 0-53.38 0-80.06 0-13.75 0-27.5-.11-41.25 0-.63 0-1.26 0-1.89 0-18.31 0-35.85 16.1-35 35 .85 18.96 15.38 35 35 35h28.6 72.37 96 99.47 82.8 45.97 35.09 94.03 43.03 88.2 6.59c18.31 0 35.85-16.1 35-35-.85-18.97-15.38-35-35-35z" />
            <path d="m267.52 610.49v107.62 170.1 38.89c0 18.31 16.1 35.85 35 35 18.96-.85 35-15.38 35-35 0-35.87 0-71.75 0-107.62 0-56.7 0-113.4 0-170.1 0-12.96 0-25.92 0-38.89 0-18.31-16.1-35.85-35-35-18.97.85-35 15.37-35 35z" />
            <path d="m406.41 610.49v107.62 170.1 38.89c0 18.31 16.1 35.85 35 35 18.96-.85 35-15.38 35-35 0-35.87 0-71.75 0-107.62 0-56.7 0-113.4 0-170.1 0-12.96 0-25.92 0-38.89 0-18.31-16.1-35.85-35-35-18.96.85-35 15.37-35 35z" />
            <path d="m546.31 610.49v107.62 170.1 38.89c0 18.31 16.1 35.85 35 35 18.96-.85 35-15.38 35-35 0-35.87 0-71.75 0-107.62 0-56.7 0-113.4 0-170.1 0-12.96 0-25.92 0-38.89 0-18.31-16.1-35.85-35-35-18.96.85-35 15.37-35 35z" />
            <path d="m685.2 610.49v107.62 170.1 38.89c0 18.31 16.1 35.85 35 35 18.96-.85 35-15.38 35-35 0-35.87 0-71.75 0-107.62 0-56.7 0-113.4 0-170.1 0-12.96 0-25.92 0-38.89 0-18.31-16.1-35.85-35-35-18.96.85-35 15.37-35 35z" />
            <path d="m302.05 477.25c0-12.22 0-24.44 0-36.66 0-29.34 0-58.69 0-88.03 0-35.65 0-71.31 0-106.96 0-30.62 0-61.24 0-91.85 0-14.76.25-29.54 0-44.29-.01-.65.04-1.27.08-1.93-.42 3.1-.83 6.2-1.25 9.3.1-.89.31-1.76.61-2.6-1.18 2.79-2.35 5.57-3.53 8.36.54-1.27 1.1-2.27 1.9-3.4-1.82 2.36-3.65 4.72-5.47 7.08.54-.68 1.15-1.28 1.83-1.83-2.36 1.82-4.72 3.65-7.08 5.47 1.12-.81 2.13-1.37 3.4-1.9-2.79 1.18-5.57 2.35-8.36 3.53.84-.3 1.71-.5 2.6-.61-3.1.42-6.2.83-9.3 1.25 15.64-.9 31.56-.08 47.22-.08h111.17 134.63 116.23c18.63 0 37.29-.35 55.92 0 .71.01 1.37.04 2.1.08-3.1-.42-6.2-.83-9.3-1.25.89.1 1.76.31 2.6.61-2.79-1.18-5.57-2.35-8.36-3.53 1.27.54 2.27 1.1 3.4 1.9-2.36-1.82-4.72-3.65-7.08-5.47.68.54 1.28 1.15 1.83 1.83-1.82-2.36-3.65-4.72-5.47-7.08.81 1.12 1.37 2.13 1.9 3.4-1.18-2.79-2.35-5.57-3.53-8.36.3.84.5 1.71.61 2.6-.42-3.1-.83-6.2-1.25-9.3.72 12.4.08 25 .08 37.41v87.71 106.94 92.14c0 14.95-.29 29.93 0 44.88v.65c0 18.31 16.1 35.85 35 35 18.96-.85 35-15.38 35-35 0-30.56 0-61.12 0-91.68 0-57.8 0-115.6 0-173.4 0-34.19.82-68.5 0-102.68-.63-26.35-20.64-46.89-47.21-47.4-2.8-.05-5.6 0-8.4 0-14.82 0-29.64 0-44.46 0-52.51 0-105.01 0-157.52 0-56.33 0-112.66 0-168.99 0-28.13 0-56.32-.56-84.45 0-26.5.52-46.61 21.3-47.08 47.6-.07 3.75 0 7.52 0 11.27v54.14 169.8 125.73 6.62c0 18.31 16.1 35.85 35 35 18.94-.85 34.98-15.38 34.98-35.01z" />
            <path d="m476.1 97.1v37.83 90.83 109.87 94.6c0 15.44-.3 30.91 0 46.35v.67c0 18.31 16.1 35.85 35 35 18.96-.85 35-15.38 35-35 0-12.61 0-25.22 0-37.83 0-30.28 0-60.56 0-90.83 0-36.62 0-73.25 0-109.87 0-31.53 0-63.07 0-94.6 0-15.44.3-30.91 0-46.35 0-.22 0-.45 0-.67 0-18.31-16.1-35.85-35-35-18.96.85-35 15.37-35 35z" />
            <path d="m267.05 318.53h48.48 116.46 140.94 121.93c19.8 0 39.63.33 59.43 0h.87c18.31 0 35.85-16.1 35-35-.85-18.96-15.38-35-35-35-16.16 0-32.32 0-48.48 0-38.82 0-77.64 0-116.46 0-46.98 0-93.96 0-140.94 0-40.64 0-81.29 0-121.93 0-19.8 0-39.63-.33-59.43 0-.29 0-.58 0-.87 0-18.31 0-35.85 16.1-35 35 .85 18.96 15.38 35 35 35z" />
            <path d="m130.92 565.52v35.96 86.35 104.47 90.31c0 14.61-.29 29.26 0 43.87v.61c0 18.31 16.1 35.85 35 35 18.96-.85 35-15.38 35-35 0-11.99 0-23.97 0-35.96 0-28.78 0-57.57 0-86.35 0-34.82 0-69.65 0-104.47 0-30.1 0-60.21 0-90.31 0-14.61.29-29.26 0-43.87 0-.2 0-.41 0-.61 0-18.31-16.1-35.85-35-35-18.96.85-35 15.38-35 35z" />
            <path d="m893.08 927.1c0-12.02 0-24.03 0-36.05 0-28.68 0-57.36 0-86.04 0-34.85 0-69.71 0-104.56 0-30 0-60 0-89.99 0-14.65.29-29.33 0-43.98 0-.2 0-.41 0-.61 0-18.31-16.1-35.85-35-35-18.96.85-35 15.38-35 35v36.05 86.04 104.56 89.99c0 14.65-.29 29.33 0 43.98v.61c0 18.31 16.1 35.85 35 35 18.96-.85 35-15.38 35-35z" />
            <path d="m120.95 962.1h20.87 56.8 84.43 102.6 112.37 113.43 105.79 89.78 64.26c10.15 0 20.31.13 30.46 0 .44-.01.88 0 1.31 0 18.31 0 35.85-16.1 35-35-.85-18.96-15.38-35-35-35-6.96 0-13.91 0-20.87 0-18.93 0-37.86 0-56.8 0-28.14 0-56.29 0-84.43 0-34.2 0-68.4 0-102.6 0-37.46 0-74.91 0-112.37 0-37.81 0-75.62 0-113.43 0-35.26 0-70.53 0-105.79 0-29.93 0-59.86 0-89.78 0-21.42 0-42.84 0-64.26 0-10.15 0-20.31-.13-30.46 0-.44.01-.88 0-1.31 0-18.31 0-35.85 16.1-35 35 .85 18.96 15.38 35 35 35z" />
        </svg>
    );
}

export function CarportIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            viewBox="0 0 68 68"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
        >
            <g fillRule="evenodd">
                <g fill="currentColor" fillRule="nonzero" transform="translate(-536 -776)">
                    <path d="m544 836c-2.209139 0-4-1.790861-4-4v-7.507577c0-.490571.060164-.979291.179145-1.455214l.910427-3.64171c.167479-.669915.42674-1.297588.762348-1.870966l-2.336991-.584248c-1.07159-.267897-1.723111-1.353766-1.455214-2.425356s1.353766-1.723111 2.425356-1.455214l3.76114.940285h2.338759l3.645247-10.328201c1.4111-3.998117 5.190076-6.671799 9.429904-6.671799h20.679758c4.239828 0 8.018804 2.673682 9.429904 6.671799l3.645247 10.328201h2.338759l3.76114-.940285c1.07159-.267897 2.157459.383624 2.425356 1.455214s-.383624 2.157459-1.455214 2.425356l-2.336991.584248c.335608.573378.594869 1.201051.762348 1.870966l.910427 3.64171c.118981.475923.179145.964643.179145 1.455214v7.507577c0 2.209139-1.790861 4-4 4v4c0 2.209139-1.790861 4-4 4h-8c-2.209139 0-4-1.790861-4-4v-4h-20v4c0 2.209139-1.790861 4-4 4h-8c-2.209139 0-4-1.790861-4-4zm45.173205-22-3.175384-8.996921c-.84666-2.39887-3.114045-4.003079-5.657942-4.003079h-20.679758c-2.543897 0-4.811282 1.604209-5.657942 4.003079l-3.175384 8.996921zm-5.873459 18h12.700254v-7.507577c0-.163524-.020055-.326431-.059715-.485072l-.910428-3.64171c-.347575-1.390303-1.596765-2.365641-3.029857-2.365641h-44c-1.433092 0-2.682282.975338-3.029857 2.365641l-.910428 3.64171c-.03966.158641-.059715.321548-.059715.485072v7.507577h12.700254l3.472123-7.812277c.321003-.722256 1.037246-1.187723 1.827623-1.187723h16c.790377 0 1.50662.465467 1.827623 1.187723zm8.700254 4h-8v4h8zm-13.077524-4-2.222222-5h-13.400508l-2.222222 5zm-30.922476 4v4h8v-4zm-9.198362-42.167685c-1.01196.442732-2.19122-.018718-2.633953-1.030677-.442732-1.01196.018718-2.19122 1.030677-2.633953l32-14c.511041-.22358 1.092235-.22358 1.603276 0l32 14c1.011959.442733 1.473409 1.621993 1.030677 2.633953-.442733 1.011959-1.621993 1.473409-2.633953 1.030677l-31.198362-13.649284zm51.198362 33.167685c-1.656854 0-3-1.343146-3-3s1.343146-3 3-3 3 1.343146 3 3-1.343146 3-3 3zm-40 0c-1.656854 0-3-1.343146-3-3s1.343146-3 3-3 3 1.343146 3 3-1.343146 3-3 3z" />
                </g>
            </g>
        </svg>
    );
}

export function GarageIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            viewBox="0 0 32 32"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
        >
            <path d="m31.591 12.193-15-11a1 1 0 0 0 -1.182 0l-15 11a1 1 0 0 0 1.182 1.614l1.409-1.033v16.226a2 2 0 0 0 2 2h22a2 2 0 0 0 2-2v-16.226l1.409 1.033a1 1 0 0 0 1.182-1.614zm-8.591 8.807h-14v-2h14zm-14 2h14v2h-14zm14-6h-14v-2h14zm-14 10h14v2h-14zm18 2h-2v-14a2 2 0 0 0 -2-2h-14a2 2 0 0 0 -2 2v14h-2v-17.693l11-8.067 11 8.067z" />
            <path d="m12 10a1 1 0 0 0 1 1h5a1 1 0 0 0 0-2h-5a1 1 0 0 0 -1 1z" />
        </svg>
    );
}

export function LoggiaIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            viewBox="0 0 1024 1024"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
        >
            <path d="M858.08,608.82H209.07c-13.75,0-27.5-.11-41.25,0h-1.89c-18.31,0-35.85,16.1-35,35,.85,18.96,15.38,35,35,35h692.15c18.31,0,35.85-16.1,35-35-.85-18.97-15.38-35-35-35z" />
            <path d="M858.07,28.56H209.06c-13.75,0-27.5-.11-41.25,0h-1.89c-18.31,0-35.85,16.1-35,35,.85,18.96,15.38,35,35,35h692.15c18.31,0,35.85-16.1,35-35-.85-18.97-15.38-35-35-35z" />
            <path d="M267.52,643.82v316.61c0,18.31,16.1,35.85,35,35,18.96-.85,35-15.38,35-35v-316.61c0-18.31-16.1-35.85-35-35-18.97.85-35,15.37-35,35z" />
            <path d="M406.41,643.82v316.61c0,18.31,16.1,35.85,35,35,18.96-.85,35-15.38,35-35v-316.61c0-18.31-16.1-35.85-35-35-18.96.85-35,15.37-35,35z" />
            <path d="M546.31,643.82v316.61c0,18.31,16.1,35.85,35,35,18.96-.85,35-15.38,35-35v-316.61c0-18.31-16.1-35.85-35-35-18.96.85-35,15.37-35,35z" />
            <path d="M685.2,643.82v316.61c0,18.31,16.1,35.85,35,35,18.96-.85,35-15.38,35-35v-316.61c0-18.31-16.1-35.85-35-35-18.96.85-35,15.37-35,35z" />
            <path d="M302.05,543.74V220.24c0-14.76.25-29.54,0-44.29-.01-.65.04-1.27.08-1.93-.42,3.1-.83,6.2-1.25,9.3.1-.89.31-1.76.61-2.6-1.18,2.79-2.35,5.57-3.53,8.36.54-1.27,1.1-2.27,1.9-3.4-1.82,2.36-3.65,4.72-5.47,7.08.54-.68,1.15-1.28,1.83-1.83-2.36,1.82-4.72,3.65-7.08,5.47,1.12-.81,2.13-1.37,3.4-1.9-2.79,1.18-5.57,2.35-8.36,3.53.84-.3,1.71-.5,2.6-.61-3.1.42-6.2.83-9.3,1.25,15.64-.9,31.56-.08,47.22-.08h362.03c18.63,0,37.29-.35,55.92,0,.71,0,1.37.04,2.1.08-3.1-.42-6.2-.83-9.3-1.25.89.1,1.76.31,2.6.61-2.79-1.18-5.57-2.35-8.36-3.53,1.27.54,2.27,1.1,3.4,1.9-2.36-1.82-4.72-3.65-7.08-5.47.68.54,1.28,1.15,1.83,1.83-1.82-2.36-3.65-4.72-5.47-7.08.81,1.12,1.37,2.13,1.9,3.4-1.18-2.79-2.35-5.57-3.53-8.36.3.84.5,1.71.61,2.6-.42-3.1-.83-6.2-1.25-9.3.72,12.4.08,25,.08,37.41v286.79c0,14.95-.29,29.93,0,44.88v.65c0,18.31,16.1,35.85,35,35,18.96-.85,35-15.38,35-35v-265.08c0-34.19.82-68.5,0-102.68-.63-26.35-20.64-46.89-47.21-47.4-2.8-.05-5.6,0-8.4,0h-370.97c-28.13,0-56.32-.56-84.45,0-26.5.52-46.61,21.3-47.08,47.6-.07,3.75,0,7.52,0,11.27v356.29c0,18.31,16.1,35.85,35,35,18.94-.85,34.98-15.38,34.98-35.01z" />
            <path d="M476.1,163.59v333.13c0,15.44-.3,30.91,0,46.35v.67c0,18.31,16.1,35.85,35,35,18.96-.85,35-15.38,35-35V210.61c0-15.44.3-30.91,0-46.35v-.67c0-18.31-16.1-35.85-35-35-18.96.85-35,15.37-35,35z" />
            <path d="M267.05,385.02h427.81c19.8,0,39.63.33,59.43,0h.87c18.31,0,35.85-16.1,35-35-.85-18.96-15.38-35-35-35h-427.81c-19.8,0-39.63-.33-59.43,0h-.87c-18.31,0-35.85,16.1-35,35,.85,18.96,15.38,35,35,35z" />
            <path d="M130.92,598.85v317.09c0,14.61-.29,29.26,0,43.87v.61c0,18.31,16.1,35.85,35,35,18.96-.85,35-15.38,35-35v-317.09c0-14.61.29-29.26,0-43.87v-.61c0-18.31-16.1-35.85-35-35-18.96.85-35,15.38-35,35z" />
            <path d="M893.08,960.43v-316.64c0-14.65.29-29.33,0-43.98v-.61c0-18.31-16.1-35.85-35-35-18.96.85-35,15.38-35,35v316.64c0,14.65-.29,29.33,0,43.98v.61c0,18.31,16.1,35.85,35,35,18.96-.85,35-15.38,35-35z" />
            <path d="M130.92,420.19v317.09c0,14.61-.29,29.26,0,43.87v.61c0,18.31,16.1,35.85,35,35,18.96-.85,35-15.38,35-35v-317.09c0-14.61.29-29.26,0-43.87v-.61c0-18.31-16.1-35.85-35-35-18.96.85-35,15.38-35,35z" />
            <path d="M893.08,781.77v-316.64c0-14.65.29-29.33,0-43.98v-.61c0-18.31-16.1-35.85-35-35-18.96.85-35,15.38-35,35v316.64c0,14.65-.29,29.33,0,43.98v.61c0,18.31,16.1,35.85,35,35,18.96-.85,35-15.38,35-35z" />
            <path d="M130.92,63.54v317.09c0,14.61-.29,29.26,0,43.87v.61c0,18.31,16.1,35.85,35,35,18.96-.85,35-15.38,35-35V108.02c0-14.61.29-29.26,0-43.87v-.61c0-18.31-16.1-35.85-35-35-18.96.85-35,15.38-35,35z" />
            <path d="M893.08,425.12V108.48c0-14.65.29-29.33,0-43.98v-.61c0-18.31-16.1-35.85-35-35-18.96.85-35,15.38-35,35v316.64c0,14.65-.29,29.33,0,43.98v.61c0,18.31,16.1,35.85,35,35,18.96-.85,35-15.38,35-35z" />
            <path d="M120.95,995.43h750.33c10.15,0,20.31.13,30.46,0,.44-.01.88,0,1.31,0,18.31,0,35.85-16.1,35-35-.85-18.96-15.38-35-35-35H152.72c-10.15,0-20.31-.13-30.46,0-.44.01-.88,0-1.31,0-18.31,0-35.85,16.1-35,35,.85,18.96,15.38,35,35,35z" />
        </svg>
    );
}

export function MonthlyExpensesIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            viewBox="0 0 32 32"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
        >
            <path d="m18.59 11.73h1.21a.75.75 0 1 1 0 1.51h-2.8a1.07 1.07 0 0 0 0 2.13h1.12v.63a1.07 1.07 0 1 0 2.13 0v-.67a2.88 2.88 0 0 0 -.46-5.73h-1.2a.75.75 0 1 1 0-1.51h2.79a1.07 1.07 0 1 0 0-2.13h-1.11v-.63a1.07 1.07 0 0 0 -2.13 0v.67a2.88 2.88 0 0 0 .46 5.73z" />
            <path d="m31.06.94a3.22 3.22 0 0 0 -2.26-.94h-19.2a3.22 3.22 0 0 0 -2.26.94 3.18 3.18 0 0 0 -.94 2.26v13.87h-3.2a3.2 3.2 0 0 0 -3.2 3.19v7.47a4.27 4.27 0 0 0 4.27 4.27h22.4a5.34 5.34 0 0 0 5.33-5.33v-23.47a3.18 3.18 0 0 0 -.94-2.26zm-28.93 26.79v-7.47a1.06 1.06 0 0 1 1.07-1.06h3.2v8.53a2.13 2.13 0 1 1 -4.27 0zm27.73-1.07a3.2 3.2 0 0 1 -3.2 3.2h-18.72a4.22 4.22 0 0 0 .59-2.13v-24.53a1.07 1.07 0 0 1 1.07-1.07h19.2a1.07 1.07 0 0 1 1.07 1.07z" />
            <path d="m24.53 20.27h-10.66a1.07 1.07 0 1 0 0 2.13h10.66a1.07 1.07 0 1 0 0-2.13z" />
            <path d="m24.53 25.6h-10.66a1.07 1.07 0 1 0 0 2.13h10.66a1.07 1.07 0 1 0 0-2.13z" />
        </svg>
    );
}

export function CellarIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            viewBox="0 0 512 512"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
        >
            <path d="m256 0c99.801 0 180.706 80.905 180.706 180.706v316.235c0 8.317-6.742 15.059-15.059 15.059h-331.294c-8.317 0-15.059-6.742-15.059-15.059v-316.235c0-99.801 80.905-180.706 180.706-180.706zm-150.588 406.588h37.647v-60.235c0-8.317 6.742-15.059 15.059-15.059h52.706v-60.235c0-8.317 6.742-15.059 15.059-15.059h52.706v-60.235c0-8.317 6.742-15.059 15.059-15.059h112.941c0-83.168-67.421-150.588-150.588-150.588s-150.589 67.42-150.589 150.588zm0 30.118v45.176h301.176v-45.176zm67.764-75.294v45.176h233.412v-45.176zm67.765-75.294v45.176h165.647v-45.176zm67.765-75.294v45.176h97.882v-45.176z" />
        </svg>
    );
}

export function RoomCountIcon(props: Props) {
    const s = {
        fill: 'none',
        stroke: 'currentColor',
        strokeWidth: 30,
        strokeLinecap: 'round' as const,
        strokeLinejoin: 'round' as const,
        strokeMiterlimit: 10,
    };
    return (
        <svg
            className={cn(props.className)}
            viewBox="0 0 682.66669 682.66669"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)">
                <g transform="translate(63.3184,301.3359)">
                    <path
                        d="m 0,0 v 113.007 c 0,19.757 16.019,35.773 35.779,35.773 h 313.805 c 19.76,0 35.779,-16.016 35.779,-35.773 V 0"
                        style={s}
                    />
                </g>
                <g transform="translate(478.4126,90.3101)">
                    <path
                        d="m 0,0 h -444.825 c -10.266,0 -18.588,8.322 -18.588,18.587 V 132.57 c 0,10.265 8.322,18.587 18.588,18.587 H 0 c 10.266,0 18.587,-8.322 18.587,-18.587 V 18.587 C 18.587,8.322 10.266,0 0,0 Z"
                        style={s}
                    />
                </g>
                <g transform="translate(472.0088,241.4673)">
                    <path
                        d="m 0,0 v 23.613 c 0,20.023 -16.235,36.256 -36.262,36.256 h -359.494 c -20.027,0 -36.262,-16.233 -36.262,-36.256 V 0"
                        style={s}
                    />
                </g>
                <g transform="translate(212.2891,301.3359)">
                    <path
                        d="m 0,0 c 10.23,0 18.523,8.292 18.523,18.521 v 22.828 c 0,10.228 -8.293,18.52 -18.523,18.52 h -80.548 c -10.231,0 -18.524,-8.292 -18.524,-18.52 V 18.521 C -99.072,8.292 -90.779,0 -80.548,0"
                        style={s}
                    />
                </g>
                <g transform="translate(380.2593,301.3359)">
                    <path
                        d="m 0,0 c 10.23,0 18.523,8.292 18.523,18.521 v 22.828 c 0,10.228 -8.293,18.52 -18.523,18.52 h -80.548 c -10.23,0 -18.524,-8.292 -18.524,-18.52 V 18.521 C -99.072,8.292 -90.778,0 -80.548,0"
                        style={s}
                    />
                </g>
                <g transform="translate(46.9248,90.3101)">
                    <path d="M 0,0 V -28.426" style={s} />
                </g>
                <g transform="translate(465.0752,90.3101)">
                    <path d="M 0,0 V -28.426" style={s} />
                </g>
            </g>
        </svg>
    );
}

export function FloorCountIcon(props: Props) {
    const s = {
        fill: 'none',
        stroke: 'currentColor',
        strokeWidth: 30,
        strokeLinecap: 'round' as const,
        strokeLinejoin: 'round' as const,
        strokeMiterlimit: 10,
    };
    return (
        <svg
            className={cn(props.className)}
            viewBox="0 0 682.66669 682.66669"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)">
                <path d="M 255,151 H 15 V 81 h 240 z" style={s} />
                <path d="M 435,431 H 195 v -70 h 240 z" style={s} />
                <path d="M 390,361 H 150 v -70 h 240 z" style={s} />
                <path d="M 345,291 H 105 v -70 h 240 z" style={s} />
                <path d="M 300,221 H 60 v -70 h 240 z" style={s} />
                <g transform="translate(255,81)">
                    <path d="M 0,0 H 242 V 350 H 180" style={s} />
                </g>
            </g>
        </svg>
    );
}

export function TerraceIcon(props: Props) {
    const s = {
        fill: 'none',
        stroke: 'currentColor',
        strokeWidth: 30,
        strokeLinecap: 'round' as const,
        strokeLinejoin: 'round' as const,
        strokeMiterlimit: 10,
    };
    return (
        <svg
            className={cn(props.className)}
            viewBox="0 0 682.66669 682.66669"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)">
                <g transform="translate(289.1431,128.0264)">
                    <path d="M 0,0 V -113.026 H -60 V 0" style={s} />
                </g>
                <path d="M 382.169,138.026 H 136.117 v 60 h 246.052 z" style={s} />
                <g transform="translate(497,223.3066)">
                    <path d="M 0,0 -11.729,-138.136" style={s} />
                </g>
                <g transform="translate(361.7417,77.3525)">
                    <path d="M 0,0 H 123.53" style={s} />
                </g>
                <g transform="translate(374.4209,15)">
                    <path d="M 0,0 20.851,59.226" style={s} />
                </g>
                <g transform="translate(485.2715,15)">
                    <path d="M 0,0 -20.851,59.226" style={s} />
                </g>
                <g transform="translate(15,223.3066)">
                    <path d="M 0,0 11.729,-138.136" style={s} />
                </g>
                <g transform="translate(150.2583,77.3525)">
                    <path d="M 0,0 H -123.53" style={s} />
                </g>
                <g transform="translate(137.5791,15)">
                    <path d="M 0,0 -20.851,59.226" style={s} />
                </g>
                <g transform="translate(26.7285,15)">
                    <path d="M 0,0 20.851,59.226" style={s} />
                </g>
                <g transform="translate(491.1826,418.7871)">
                    <path
                        d="m 0,0 c 3.71,-6.765 5.817,-14.516 5.817,-22.755 0,-26.364 -21.58,-47.737 -48.2,-47.737 -26.62,0 -48.2,21.373 -48.2,47.737 0,-26.364 -21.58,-47.737 -48.2,-47.737 -26.62,0 -48.199,21.373 -48.199,47.737 0,-26.364 -21.58,-47.737 -48.201,-47.737 -26.62,0 -48.2,21.373 -48.2,47.737 0,-26.364 -21.579,-47.737 -48.2,-47.737 -26.62,0 -48.2,21.373 -48.2,47.737 0,-26.364 -21.579,-47.737 -48.199,-47.737 -26.621,0 -48.201,21.373 -48.201,47.737 0,8.063 2.018,15.659 5.582,22.319"
                        style={s}
                    />
                </g>
                <g transform="translate(491.1826,418.3496)">
                    <path d="m 0,0 -470.601,0.002 36.28,78.648 h 400.214 z" style={s} />
                </g>
                <g transform="translate(111.3999,396.0322)">
                    <path d="M 0,0 V 21.755" style={s} />
                </g>
                <g transform="translate(207.7998,396.0322)">
                    <path d="M 0,0 V 21.755" style={s} />
                </g>
                <g transform="translate(304.2002,396.0322)">
                    <path d="M 0,0 V 21.755" style={s} />
                </g>
                <g transform="translate(400.6001,396.0322)">
                    <path d="M 0,0 V 21.755" style={s} />
                </g>
            </g>
        </svg>
    );
}

export function OutdoorParkingIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            viewBox="0 0 512 512"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
        >
            <path d="m442.707031 182.582031-53.808593-26.902343c-4.46875-18.058594-18.199219-73.542969-22.667969-91.59375-5.015625-20.070313-22.964844-34.085938-43.652344-34.085938h-133.15625c-20.6875 0-38.636719 14.015625-43.664063 34.121094-4.457031 18.011718-18.1875 73.503906-22.65625 91.558594l-53.808593 26.90625c-7.410157 3.703124-10.414063 12.714843-6.707031 20.125 3.703124 7.40625 12.710937 10.410156 20.121093 6.707031l38.292969-19.148438v246.730469c0 24.8125 20.1875 45 45 45h180c24.8125 0 45-20.1875 45-45 0-11.199219 0-237.648438 0-246.730469l38.292969 19.148438c7.410156 3.703125 16.417969.699219 20.121093-6.707031 3.707032-7.410157.703126-16.421876-6.707031-20.128907zm-231.707031 178.417969v-90h90v90zm-48.164062-241h33.164062c24.8125 0 45-20.1875 45-45v-15h30v15c0 24.8125 20.1875 45 45 45h33.164062l7.671876 31h-201.671876zm-11.835938 95.542969 30 45v40.457031h-30zm0 115.457031h30v35.730469l-30 15zm180 0h30v50.730469l-30-15zm30-30h-30v-40.457031l30-45zm-53.027344-60h-103.945312l-40-60h183.945312zm29.148438-169.671875 4.621094 18.671875h-25.742188c-8.269531 0-15-6.730469-15-15v-15h21.578125c6.894531 0 12.878906 4.671875 14.542969 11.328125zm-147.699219-11.328125h21.578125v15c0 8.269531-6.730469 15-15 15h-25.742188l4.613282-18.636719c1.671875-6.691406 7.65625-11.363281 14.550781-11.363281zm156.578125 392h-180c-8.269531 0-15-6.730469-15-15v-21.730469l48.539062-24.269531h112.921876l48.539062 24.269531v21.730469c0 8.269531-6.730469 15-15 15zm0 0" />
            <path d="m15 0c-8.285156 0-15 6.714844-15 15v482c0 8.285156 6.714844 15 15 15s15-6.714844 15-15v-482c0-8.285156-6.714844-15-15-15zm0 0" />
            <path d="m497 0c-8.285156 0-15 6.714844-15 15v482c0 8.285156 6.714844 15 15 15s15-6.714844 15-15v-482c0-8.285156-6.714844-15-15-15zm0 0" />
        </svg>
    );
}

export function FurnishingsIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            viewBox="0 0 32 32"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
        >
            <path d="m28 11v-5c0-2.8-2.2-5-5-5h-14c-2.8 0-5 2.2-5 5v5c-1.1 0-2 .9-2 2v9c0 2.1 1.7 3.9 3.8 4l-.8 3.8c-.1.6.4 1.2 1 1.2.5 0 .9-.3 1-.8l.8-4.2h16.4l.8 4.2c.1.5.5.8 1 .8.6 0 1.1-.6 1-1.2 0 0-.8-3.8-.8-3.8 2.1-.1 3.8-1.8 3.8-4v-9c0-1.1-.9-2-2-2zm-22-5c0-1.7 1.3-3 3-3h14c1.7 0 3 1.3 3 3v5h-.7c-1.1 0-2 .9-2 2v1.7c-.7-.4-1.5-.7-2.3-.7h-10c-.8 0-1.6.3-2.3.7v-1.7c0-1.1-.9-2-2-2h-.7zm17 13.3h-14v-1.3c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2zm5 2.7c0 1.1-.9 2-2 2h-20c-1.1 0-2-.9-2-2v-9h2.7v6.3c0 .4.2.9.4 1.2.1.2.2.3.4.4.3.2.7.4 1.2.4h14.5c.4 0 .8-.1 1.2-.4.2-.1.3-.2.4-.4.2-.3.4-.7.4-1.2v-6.3h2.8z" />
        </svg>
    );
}

export function EuroIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 481.569 481.569"
        >
            <g>
                <path d="M444.288,429.288c-5.4-13.2-10.9-26.4-16.9-39.4c-5.3-11.6-12.1-15-24.8-12.1c-16.1,3.7-31.9,8.6-48,11.9   c-31.1,6.5-62.3,7.1-93-2.6c-38.5-12.1-59-40-71.6-76h104.4c8.2,0,14.8-6.6,14.8-14.8v-32.9c0-8.2-6.6-14.8-14.8-14.8h-114.4   c0-9.2-0.1-18,0-26.8h114.4c8.2,0,14.8-6.6,14.8-14.8v-32.9c0-8.2-6.6-14.8-14.8-14.8h-100c0-0.4,0-0.8,0.2-1   c12-27.3,29.5-49.2,58.2-60.6c33.4-13.2,67.5-12.9,101.9-5.8c16.3,3.3,32.3,8.3,48.6,12c11.9,2.7,18.8-0.8,23.9-11.9   c5.9-12.8,11.3-25.8,16.7-38.9c5.1-12.3,2.1-21-9.5-27.8c-2.9-1.7-5.9-3.1-9-4.3c-48.2-18.8-97.9-25.8-149.2-17.6   c-36.1,5.8-69.8,18.2-98.9,40.8c-36.7,28.4-60.5,65.9-74.3,110l-1.7,5.1h-51.4c-8.2,0-14.8,6.6-14.8,14.8v32.9   c0,8.2,6.6,14.8,14.8,14.8h40.5c0,9,0,17.7,0,26.8h-40.5c-8.2,0-14.8,6.6-14.8,14.8v32.9c0,8.2,6.6,14.8,14.8,14.8h48.8   c3.7,12,6.8,24.2,11.5,35.7c24.7,59.6,66.1,102,128.4,122.2c51.5,16.7,103.4,16.2,155.3,1.9c13.5-3.7,26.9-8.5,39.7-14.4   C445.988,450.788,449.188,441.188,444.288,429.288z" />
            </g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
        </svg>
    );
}

export function NewBuildingIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            id="Glyph"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="0 0 448 421.46"
        >
            <path d="M207.03,146.29H8.62C3.87,146.27.02,150.1,0,154.85c0,.02,0,.04,0,.06v111.66c.01,4.75,3.86,8.6,8.62,8.62h198.41c4.75-.03,8.58-3.87,8.62-8.62v-111.66c.02-4.74-3.81-8.6-8.55-8.62-.02,0-.04,0-.06,0Z" />
            <path d="M439.38,146.29h-198.41c-4.74-.02-8.6,3.81-8.62,8.55,0,.02,0,.05,0,.07v111.65c.03,4.74,3.87,8.58,8.62,8.62h198.41c4.75-.01,8.6-3.86,8.62-8.62v-111.66c.02-4.74-3.81-8.6-8.56-8.62-.02,0-.04,0-.06,0h0Z" />
            <path d="M124.75,128.89h198.5c4.74.02,8.6-3.81,8.62-8.56,0-.02,0-.04,0-.06V8.62c-.01-4.75-3.86-8.6-8.62-8.62H124.75c-4.75.01-8.6,3.86-8.62,8.62v111.66c-.02,4.74,3.81,8.6,8.56,8.61.02,0,.04,0,.06,0Z" />
            <path d="M124.75,421.46h198.5c4.74.02,8.6-3.81,8.62-8.56,0-.02,0-.04,0-.06v-111.66c-.01-4.75-3.86-8.6-8.62-8.62H124.75c-4.75.01-8.6,3.86-8.62,8.62v111.66c-.02,4.74,3.81,8.6,8.56,8.61.02,0,.04,0,.06,0Z" />
        </svg>
    );
}

export function AreaArrowIcon(props: Props) {
    return (
        <svg
            className={cn(props.className)}
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 448 448"
        >
            <g>
                <g>
                    <path d="M438.112,281.44c-5.984-2.496-12.864-1.088-17.44,3.456l-33.952,33.952l-257.6-257.6l33.952-33.952    c4.576-4.576,5.952-11.456,3.456-17.44C164.064,3.904,158.24,0,151.776,0H16C7.168,0,0,7.168,0,16v135.776    c0,6.464,3.904,12.288,9.888,14.784c5.984,2.496,12.864,1.088,17.44-3.456l33.952-33.952l257.6,257.6l-33.952,33.952    c-4.576,4.576-5.952,11.456-3.456,17.44c2.464,5.952,8.288,9.856,14.752,9.856H432c8.832,0,16-7.168,16-16V296.224    C448,289.76,444.096,283.936,438.112,281.44z" />
                </g>
            </g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
        </svg>
    );
}
